import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

type State = {
  showFullChart: boolean
  setShowFullChart: (value: boolean) => void
}

export const useBusinessTripChartViewStore = create<State>()(
  persist(
    (set) => ({
      showFullChart: true,
      setShowFullChart: (value) => set({ showFullChart: value }),
    }),
    {
      name: 'business-trip-chart-view',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
